module.exports = __webpack_public_path__ + "img/stop_points_create_light.b78429ab.gif";